module.exports = __webpack_public_path__ + "static/media/Thank_you.c2e43e72.svg";